import Input from 'element-ui/lib/input';
import _ from 'lodash';
import { MAX_STRING_LENGTH } from '../../../utils';
export default {
    name: 'StringEditor',
    components: {
        ElInput: Input,
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            value$: this.value,
            MAX_STRING_LENGTH,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.value$ = this.value;
            },
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.inputRef) {
                this.$refs.inputRef.focus();
            }
        });
    },
    methods: {
        onEnter() {
            if (this.$refs.inputRef) {
                this.$refs.inputRef.blur();
            }
        },
        onFinishEdit() {
            this.$emit('endLabelingField');
            this.$emit('updateFieldValue', _.trim(this.value$));
        },
    },
};
